import React, {Component} from 'react';
import {connect} from 'react-redux';

import {chatActions, chatSelectors} from "../../store/chat";
import Layout from '../../components/Layout'
import Chat from '../../pages/Chat'
import Loading from '../../components/Base/Loading'


class ChatContainer extends Component {

	constructor(props) {
		super(props);
		//this.listener = () => {
			//console.log('listening')
		//};
		this.state = {
			width: 0,
			height: 0,
			studentMap: [],
			facultyMap: [],
			loading: false,
			chats: [],
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		//this.fetchUsers();
	}

	fetchUsers  = async () => {
		this.setState({loading : true});
		let studentMap = {}, facultyMap = [];
		let studentRef = await this.props.firebase.students().get();
		studentRef.docs.forEach(doc => studentMap[doc.id] = doc.data());

		let facultyRef = await this.props.firebase.faculties().get();
		facultyRef.docs.forEach(doc => facultyMap[doc.id] = doc.data());

		this.setState({
			studentMap,
			facultyMap,
			loading: false
		});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		// this.listener()
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	render() {
		const {loading} = this.state;
		const {profile} = this.props;
		return (
			<Layout {...this.props}>
				{profile === null || profile === undefined || loading? <Loading/> :

					<Chat {...this.props} {...this.state} />}
			</Layout>
		);
	}
}

const mapStateToProps = (state) => ({
	currentChat: chatSelectors.refreshCurrentID(state.chat)

});

const mapDispatchToProps = (dispatch) => ({
	updateChatId: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	},
});


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChatContainer);
